module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Calisto MT",
      "font-size": "18pt",
      "letter-spacing": "1px",
      "padding-top": "75px",
      "padding-bottom": "15px"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_vm._v("David Johnson has had three non-fiction books about the First World War published – "), _c('em', [_vm._v("One Soldier and Hitler, 1918: The Story of Henry Tandey VC DCM MM / The Man Who Didn’t Shoot Hitler: The Story of Henry Tandey VC and Adolf Hitler, 1918")]), _vm._v("; "), _c('em', [_vm._v("Executed at Dawn: British Firing Squads on the Western Front 1914-1918")]), _vm._v("; "), _c('em', [_vm._v("The Last Campaign of World War One (1990 – 2006): The Fight to Win Pardons for Those Executed.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('em', [_vm._v("The Enemy at Home")]), _vm._v(" is his first novel to be published and again it is set in the First World War.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0